import React, { forwardRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { useSetTag, useDeleteTag } from "./store";

const MultiSelect = forwardRef(
  ({ options, placeholder, customer, ...rest }, ref) => {
    const { setTagToCase } = useSetTag();
    const { deleteTagFromCase } = useDeleteTag();

    const [selectedTags, setSelectedTags] = useState([]);

    useEffect(() => {
      setSelectedTags(
        customer.caseTags.map((tag) => ({
          id: tag.tag_id,
          value: tag.tag.display_name.replace(/ /g, "_").toLowerCase(),
          label: tag.tag.display_name,
        }))
      );
    }, [customer.id]);

    const handleChange = (selected) => {
      setSelectedTags(selected);

      const addedTags = selected.filter(
        (tag) => !selectedTags.find((option) => option.value === tag.value)
      )[0];

      addedTags && setTagToCase(customer.id, addedTags.id);

      const removedTags = selectedTags.filter(
        (tag) => !selected.find((option) => option.value === tag.value)
      );
      removedTags.forEach((tag) => {
        deleteTagFromCase(customer.id, tag.id);
      });
    };

    const selectStyles = {
      control: (provided) => ({
        ...provided,
        width: "100%", 
        maxHeight:"3rem",
       overflowY:"scroll"
      }),
    };

    return (
      <Select
        ref={ref}
        isMulti
        options={options}
        placeholder={placeholder}
        classNamePrefix="react-select "
        className="scrollable-container"
        value={selectedTags}
        onChange={handleChange}
        {...rest}
        styles={selectStyles} 

      />
    );
  }
);

MultiSelect.propTypes = {
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
};

export default MultiSelect;
